module.exports = __webpack_public_path__ + "img/locked-icon.974fcfab.svg";